import { Component, Input } from '@angular/core';

export interface ISkeletonColumn {
  width: string;
  label?: string;
}

@Component({
  selector: 'sgt-table-skeleton',
  templateUrl: './table-skeleton.component.html',
  styleUrls: ['./table-skeleton.component.scss'],
})
export class TableSkeletonComponent {
  @Input() columns: ISkeletonColumn[] = [];
  @Input() rows = 6;

  get skeletonRows(): number[] {
    return Array(this.rows).fill(0);
  }
}
